// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"180":"7368e892","323":"429b98d7","398":"458335ad","411":"41b27ed4","525":"1d822c64","973":"3ccb6f96"}[chunkId] + ".css";
};